import { render, staticRenderFns } from "./Liste.vue?vue&type=template&id=f531d1b8&scoped=true"
import script from "./Liste.vue?vue&type=script&lang=js"
export * from "./Liste.vue?vue&type=script&lang=js"
import style0 from "./Liste.vue?vue&type=style&index=0&id=f531d1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f531d1b8",
  null
  
)

export default component.exports